import { Grid } from '@mui/material'
import { CustomInput } from 'src/consumer/components/helperComponents'
import { allAvailableEventTypes } from 'src/consumer/constants'
import {
  GenericModalHeadlineLevelTwo,
  StyledEventInputContainer,
} from 'src/mentor/components/MentorAvailabilityPage/MentorAvailabilityPageStyles'
import { StyledPanelMemberReactSelect } from 'src/mentor/components/MentorEventsPage/MentorEventsPageStyles'

export default function PanelAndWebinarConfig({
  basicEventObject,
  setBasicEventObject,
  selectedPanelMembers,
  handleMultiSelectPanelMembersChange,
  loadOptions,
  isDisabled,
}) {
  // Phase 14bg — context-aware cache key for AsyncPaginate. The previous setup loaded
  // options once on first interaction and stuck with the cached list, so changing the
  // event type (which switches the role filter on the backend) or the clinic location
  // mid-edit didn't refresh the suggestions. cacheUniqs invalidates the cache whenever
  // any of the values in the array change identity — joining clinicLocationId + type
  // gives us a fresh fetch per (clinic, role) combination.
  const clinicLocationId =
    basicEventObject?.contextId || basicEventObject?.clinicLocationId || ''
  const eventType = basicEventObject?.type || ''
  const cacheKey = `${clinicLocationId}|${eventType}`
  return (
    <>
        <div>
          {/* Phase 14az / 14bg — relabelled "Interview Panel Members" → "Panel Members".
              The picker also serves consultations and clinic events, so the "Interview"
              qualifier was misleading. loadOptions in EventTypeCreationForm scopes to
              practitioners attached to this event's clinic location AND filters by the
              role implied by the event type (therapy-session → ROLE_THERAPIST,
              consultation → ROLE_DOCTOR, screening → ROLE_SCREENER). The picker now
              also preloads options on first render via defaultOptions so the operator
              sees suggestions immediately rather than only after clicking the field. */}
          <GenericModalHeadlineLevelTwo>Panel Members</GenericModalHeadlineLevelTwo>
          <StyledPanelMemberReactSelect
            isMulti
            value={selectedPanelMembers}
            loadOptions={loadOptions}
            getOptionValue={(option) => option.id}
            getOptionLabel={(option) => option.name}
            onChange={handleMultiSelectPanelMembersChange}
            debounceTimeout={500}
            isDisabled={isDisabled}
            additional={{
              page: 1,
            }}
            // Phase 14bg — defaultOptions={true} fires loadOptions immediately on
            // mount instead of waiting for the operator to click; cacheUniqs busts
            // the internal options cache whenever the (clinic, eventType) pair
            // changes so changing event type re-runs the role-narrowed fetch.
            defaultOptions
            cacheUniqs={[cacheKey]}
            placeholder="Search practitioners attached to this clinic…"
            noOptionsMessage={() =>
              clinicLocationId
                ? 'No other practitioners attached to this clinic match the role for this event type.'
                : 'No matches.'
            }
          />
        </div>

      {basicEventObject?.type === allAvailableEventTypes?.webinar && (
        <div>
          <Grid container spacing={1}>
            <Grid item xs={12} md={6}>
              <CustomInput
                id="minUsers"
                label={'Minimum Users'}
                value={basicEventObject?.minUsers || ''}
                inputAndMessageContainer={StyledEventInputContainer}
                placeholder="Enter the minimum users in this webinar..."
                type="number"
                isDisabled={isDisabled}
                onChange={(e) => {
                  console.log(e.target.value)
                  const inputValue = Math.max(0, parseInt(e.target.value))
                  setBasicEventObject((prev) => ({
                    ...prev,
                    minUsers: inputValue,
                  }))
                }}
                disabled={!!basicEventObject?.contextId}
                required
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <CustomInput
                id="maxUsers"
                label={'Maximum Users'}
                value={basicEventObject?.maxUsers || ''}
                inputAndMessageContainer={StyledEventInputContainer}
                placeholder="Enter the maximum users in this webinar..."
                type="number"
                onChange={(e) => {
                  console.log(e.target.value)
                  const inputValue = Math.max(0, parseInt(e.target.value))
                  setBasicEventObject((prev) => ({
                    ...prev,
                    maxUsers: inputValue,
                  }))
                }}
                disabled={isDisabled || !!basicEventObject?.contextId}
                required
              />
            </Grid>
          </Grid>
        </div>
      )}
    </>
  )
}
